module.exports = __webpack_public_path__ + "img/wallet.f7825f52.svg";